export const societies = [{
    name: "Catholic Men Organization",
    meetingDays: "Meeting days: First Sunday",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/CMO.jpg'),
    alt: "cmo"
  },
  {
    name: "Catholic Women Organization",
    meetingDays: "Meeting days: Last Sunday",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/CWO.jpg'),
    alt: "cwo"
  },
  {
    name: "Catholic Youth Organization of Nigeria",
    meetingDays: "Meeting days: First Sunday",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/CYON.jpg'),
    alt: "cyon"
  },
  {
    name: "Holy Child Hood Association",
    meetingDays: "Meeting days: First Sunday",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/mca-logo-btn.webp'),
    alt: "mca"
  },
  {
    name: "St. Anthony of Padua",
    meetingDays: "Meeting days: Every Tuesday",
    time: "5:00pm",
    imgSrc: require('../assets/societies-logos/St-Anthony.jpg'),
    alt: "st-anthony"
  },
  {
    name: "St. John",
    meetingDays: "Meeting days: Second Sunday",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/saint-john-the-apostle.jpg'),
    alt: "st-john"
  },
  {
    name: "Confraternity of Christian Mothers",
    meetingDays: "Meeting days: First Sunday",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/ccm.jpg'),
    alt: "ccm"
  },
  {
    name: "Knights of St. Mulumba",
    meetingDays: "Meeting days: First Sunday",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/ksm.jpg'),
    alt: "ksm"
  },
  {
    name: "Sacred Heart of Jesus",
    meetingDays: "Meeting days: Every Thurdays",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/sacred-heart.jpg'),
    alt: "sacred-of-jesus"
  },
  {
    name: "Board of Lectors",
    meetingDays: "Meeting days: Every Saturday",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/lectors.png'),
    alt: "board-of-lectors"
  },
  {
    name: "Block Rosary Crusade",
    meetingDays: "Meeting days: First Sunday",
    time: "After 7:00am Mass",
    imgSrc: require('../assets/societies-logos/block-rosary.jpg'),
    alt: "block-rosary"
  },
  {
    name: "Altar Servers Association",
    meetingDays: "Meeting days: Every Saturday",
    time: "9:00am",
    imgSrc: require('../assets/societies-logos/st-john-berchmann.jpg'),
    alt: "altar-servers"
  }
]
